// extracted by mini-css-extract-plugin
export default {"vl__icon":"vl__icon--31dSe","vl--ordered":"vl--ordered--4YGvW","vl__item":"vl__item--3zMdg","vl":"vl--wEfUy","vl__item--completed":"vl__item--completed--1RwQB","vl__item__title":"vl__item__title--1PkaG","vl__item__description":"vl__item__description--2DMWG"};
    if(module.hot) {
      // 1747648156367
      var cssReload = require("!../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  